<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">女の子メッセージ</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>セラピストコメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.koumoku19.text"
                      :rules="items.koumoku19.rules"
                    >
                      <v-textarea
                        ref="koumoku19"
                        v-model="cast_prop.koumoku19"
                        name="koumoku19"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.koumoku19.text"
                        :placeholder="`女の子メッセージ`"
                        rows="6"
                        outlined
                        :counter="items.koumoku19.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">店長コメント（お店から）</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>お店コメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.koumoku20.text"
                      :rules="items.koumoku20.rules"
                    >
                      <v-textarea
                        ref="koumoku20"
                        v-model="cast_prop.koumoku20"
                        name="koumoku20"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.koumoku20.text"
                        :placeholder="`店長コメント（お店から）`"
                        rows="6"
                        outlined
                        :counter="items.koumoku20.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <!-- タイプ -->
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">タイプ</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.koumoku1.text"
                      :rules="items.koumoku1.rules"
                    >
                      <v-select
                        ref="koumoku1"
                        v-model="cast_prop.koumoku1"
                        name="koumoku1"
                        :items="koumoku1Item"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.koumoku1.text"
                        outlined
                        background-color="white"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>

            <!-- 体型 -->
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">体型</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.koumoku2.text"
                      :rules="items.koumoku2.rules"
                    >
                      <v-select
                        ref="koumoku2"
                        v-model="cast_prop.koumoku2"
                        name="koumoku2"
                        :items="koumoku2Item"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.koumoku2.text"
                        outlined
                        background-color="white"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>

            <!-- テキスト項目（性感帯/得意プレイ/初体験/星座/好きなオプション） -->
            <div v-for="key in textKeys" :key="key">
              <v-row>
                <v-col cols="12" sm="2"
                  ><span class="font-weight-bold">{{
                    items[key].text
                  }}</span></v-col
                >
                <v-col cols="12" sm="10">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        v-slot="{ errors, valid }"
                        :name="items[key].text"
                        :rules="items[key].rules"
                      >
                        <v-text-field
                          v-model="cast_prop[key]"
                          :name="key"
                          :error-messages="errors"
                          :success="valid"
                          :label="items[key].text"
                          outlined
                          background-color="white"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="mt-4 mb-8"></v-divider>
            </div>

            <!-- お酒/タバコ/SM（グループ内単一選択のチェックボックス） -->
            <div v-for="group in checkboxGroups" :key="group.id">
              <v-row>
                <v-col cols="12" sm="2"
                  ><span class="font-weight-bold">{{ group.text }}</span></v-col
                >
                <v-col cols="12" sm="10">
                  <v-row class="mt-2 mb-2">
                    <v-col
                      v-for="key in group.keys"
                      :key="key"
                      cols="6"
                      sm="4"
                      md="3"
                    >
                      <v-checkbox
                        class="mt-1"
                        v-model="chk[key]"
                        :name="key"
                        :label="items[key].text"
                        @change="onExclusive(group.id, key)"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="mt-4 mb-8"></v-divider>
            </div>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // チェックボックス表示用(boolean)。cast_propの"1"/nullと相互変換する
      chk: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
    });

    // タイプ(koumoku1)の選択肢
    const TYPE_OPTIONS = [
      "10代",
      "ノースモーキング",
      "モデル系",
      "OL系",
      "現役OL",
      "現役キャバ嬢",
      "元キャバ嬢",
      "ナース系",
      "現役ナース",
      "お姉さん系",
      "妹系",
      "ロリ系",
      "コギャル系",
      "若妻系",
      "人妻系",
      "熟女系",
      "女子校女子大系",
      "現役学生",
      "美少女系",
      "女王様系",
      "M嬢",
      "責め好き",
      "責められ好き",
      "責め受け両方OK",
      "癒し系",
      "話しやすい",
      "痴女系",
      "エロ姉系",
      "ギャル系",
      "エロカワイイ系",
      "カワイイ系",
      "綺麗系",
      "清純系",
      "清楚系",
      "アイドル系",
      "小悪魔系",
      "パイパン",
      "サービス抜群",
      "地元娘",
      "AV出演",
      "無制限発射!",
      "即尺OK",
      "ごっくんOK",
      "潮吹き娘",
      "AFOK",
      "お嬢様系",
      "女教師系",
    ];
    // 体型(koumoku2)の選択肢
    const BODY_OPTIONS = [
      "スレンダー系",
      "ぽっちゃり系",
      "巨乳系",
      "ちっぱい",
      "ミクロ系",
      "セクシー系",
      "長身系",
      "モデル系",
      "グラマー系",
      "フェロモン系",
    ];
    const koumoku1Item = [
      { text: "選択して下さい", value: "" },
      ...TYPE_OPTIONS.map((v) => ({ text: v, value: v })),
    ];
    const koumoku2Item = [
      { text: "選択して下さい", value: "" },
      ...BODY_OPTIONS.map((v) => ({ text: v, value: v })),
    ];

    // テキスト項目のキー
    const textKeys = [
      "profile_json_0",
      "profile_json_1",
      "profile_json_2",
      "profile_json_3",
      "profile_json_7",
    ];

    // チェックボックスのグループ(グループ内は単一選択)
    const checkboxGroups = [
      { id: "4", text: "お酒", keys: ["profile_json_4_0", "profile_json_4_1"] },
      {
        id: "5",
        text: "タバコ",
        keys: ["profile_json_5_0", "profile_json_5_1", "profile_json_5_2"],
      },
      {
        id: "6",
        text: "ＳかＭのどちら？",
        keys: ["profile_json_6_0", "profile_json_6_1", "profile_json_6_2"],
      },
    ];
    const checkboxKeys = checkboxGroups.reduce(
      (acc, group) => acc.concat(group.keys),
      []
    );

    // 文字数制限はサイト準拠で設けない(rules空)
    const items = {
      "koumoku19": {
        text: "女の子メッセージ",
        rules: "",
        counter: "",
      },
      "koumoku20": {
        text: "店長コメント（お店から）",
        rules: "",
        counter: "",
      },
      koumoku1: { text: "タイプ", rules: "", counter: "" },
      koumoku2: { text: "体型", rules: "", counter: "" },
      profile_json_0: { text: "性感帯", rules: "", counter: "" },
      profile_json_1: { text: "得意プレイ", rules: "", counter: "" },
      profile_json_2: { text: "初体験", rules: "", counter: "" },
      profile_json_3: { text: "星座", rules: "", counter: "" },
      profile_json_7: { text: "好きなオプション", rules: "", counter: "" },
      profile_json_4_0: { text: "飲む", rules: "", counter: "" },
      profile_json_4_1: { text: "飲まない", rules: "", counter: "" },
      profile_json_5_0: { text: "吸う", rules: "", counter: "" },
      profile_json_5_1: { text: "吸わない", rules: "", counter: "" },
      profile_json_5_2: { text: "吸う(電子タバコ)", rules: "", counter: "" },
      profile_json_6_0: { text: "Ｓ", rules: "", counter: "" },
      profile_json_6_1: { text: "Ｍ", rules: "", counter: "" },
      profile_json_6_2: { text: "両方", rules: "", counter: "" },
    };

    // 画面表示用にstate.cast_propの値を整理(媒体コピー処理からreflectCastPropsで呼ばれる)
    const reflectCastProps = async () => {
      // チェックボックスのcast_prop("1"/null)を表示用booleanに変換
      checkboxKeys.forEach((key) => {
        set(state.chk, key, state.cast_prop[key] === "1");
      });
    };

    const init = async () => {
      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        set(state.cast_prop, key, props.com_data.cast_prop[key]);
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);

      // 画面表示前の後処理
      await reflectCastProps();
    };

    init();

    // チェックボックスのグループ内単一選択(チェックされたら同グループの他を外す)
    const onExclusive = (groupId, checkedKey) => {
      if (!state.chk[checkedKey]) return;
      const group = checkboxGroups.find((g) => g.id === groupId);
      group.keys.forEach((key) => {
        if (key !== checkedKey) set(state.chk, key, false);
      });
    };

    // チェック処理
    const checkValid = async () => {
      state.errorElement = null;
      return await ctx.refs.observer.validate();
    };

    const setErrorFocus = async () => {
      if (!state.errorElement) return;
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    // 保存前にcastPropsの値を整理する(媒体コピー処理からsetCastPropsで呼ばれる)
    const setCastProps = async () => {
      // 表示用booleanをcast_prop("1"/null)に戻す
      checkboxKeys.forEach((key) => {
        set(state.cast_prop, key, state.chk[key] ? "1" : null);
      });
    };

    // 保存処理
    const save = async () => {
      // 保存前にcastPropsの値を整理する
      await setCastProps();

      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:ddeli.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      setting,
      koumoku1Item,
      koumoku2Item,
      textKeys,
      checkboxGroups,
      items,
      ...toRefs(state),
      onExclusive,
      checkValid,
      setErrorFocus,
      save,
      reflectCastProps,
      setCastProps,
    };
  },
});
</script>

<style scoped></style>
